// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2n7HZ","rootCenter":"LoadMoreObserver_rootCenter__1yID-","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3ahLX"};